import {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { selectContestsByIds } from '../stores/pickX/pickX.selectors';
import {pickXApi, useGetContestsByIdsQuery} from '../stores/pickX/pickX.api';

const useFetchMissingContests = (contestIds) => {
    const contests = useSelector(state => selectContestsByIds(state, contestIds));
    const missingContestIds = contestIds.filter(id => !contests.find(c => c.Id === id));
    const { data: fetchedContests, error, isLoading } = useGetContestsByIdsQuery(missingContestIds, {
        skip: missingContestIds.length === 0,
    });
    const allContests = useMemo(() => {
        if (fetchedContests) {
            return [...contests, ...fetchedContests];
        }
        return contests;
    }, [contests, fetchedContests ?? []]);

    return { contests: allContests, error, isLoading };
};

export default useFetchMissingContests;